require('../../modules/es6.string.repeat');
module.exports = require('../../modules/_core').String.repeat;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/string/repeat.js
// module id = U9tU
// module chunks = 1